import React from "react";
import { Route, Routes } from "react-router-dom";
// import Home from "../Pages/Home";
import Blogs from "../Pages/Blogs";
// import Navbar from "../Components/Navbar";
import CreateBlogs from "../Pages/CreateBlogs";
import BlogDetails from "../Components/BlogDetails";
import EditBlog from "../Components/EditBlog";
import ConfirmDelete from "../Components/ConfirmDelete";
import TrashBlogs from "../Components/TrashBlogs";
import Error from "../Pages/Error";
import Login from "../Pages/Login";
import Signup from "../Pages/Signup";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import { Flip } from "react-toastify";
import Profile from "../Pages/Profile";

// v1 imports
import Navbar from "../Components/v1/Navbar";
import Home from "../Components/v1/Home";

const Main_Routes = () => {
  const { isAuth } = useSelector((state) => state);
  return (
    <>
      <ToastContainer transition={Flip} />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/create" element={<CreateBlogs />} />
        <Route path="/blogs/:id" element={<BlogDetails />} />
        {isAuth && <Route path="/blogs/:id/edit" element={<EditBlog />} />}
        {isAuth && (
          <Route path="/blogs/:id/delete" element={<ConfirmDelete />} />
        )}
        <Route path="/blogs/trash" element={<TrashBlogs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </>
  );
};

export default Main_Routes;
